<template>
  <div class="container" :style="{backgroundImage: `url(${require('../../assets/image/bg_container.jpg')})`}">
    <div class="page-header" :style="{backgroundImage: `url(${require('../../assets/image/bg_header.png')})`}">
      <header-time ref="headerTime"></header-time>
      <header-about></header-about>
      <header-weather ref="headerWeather"></header-weather>
    </div>

    <div class="chat-container">
      <div class="chat-box">
        <h2 class="title">DEEPSEEK数据分析</h2>
        <div v-for="(msg, index) in messages" :key="index" class="message" :class="msg.role">
          <img v-if="msg.role === 'ai'" style="width: 60px;height: 60px;margin-right: 15px;" src="../../assets/image/ai.png"/>
          <div class="bubble" v-html="parseMarkdown(msg.content)"></div>
          <img v-if="msg.role === 'user'" style="width: 60px;height: 60px;margin-left: 15px;" src="../../assets/image/user.png"/>
        </div>
      </div>
      <!-- 输入框 -->
      <div class="input-box">
        <input
            v-model="userInput"
            @keyup.enter="!loading && sendMessage"
            placeholder="输入你的问题..."
            class="input-field"
        />
        <button v-if="!loading" @click="sendMessage" class="send-button">
          发送
        </button>

        <button v-if="loading" @click="stopResponse" class="stop-button">
          停止
        </button>
      </div>


    </div>
  </div>


</template>

<script>
import marked from 'marked';
import HeaderAbout from "@/components/HeaderAbout/HeaderAbout.vue";
import HeaderWeather from "@/components/HeaderWeather/HeaderWeather.vue";
import HeaderTime from "@/components/HeaderTime/HeaderTime.vue";

export default {
  components: {HeaderTime, HeaderWeather, HeaderAbout},
  data() {
    return {
      messages: [{ role: "ai", content: "您好！我是南宁能源集团DEEPSEEK数据分析顾问，请您提问。" }],
      userInput: "",
      loading: false,
      API_KEY: "sk-e06c18b6e5a841079d5ca4925db801b7", // 替换成你的 DashScope API Key
      API_ID: "9c9e5ebb21cf4a6580cc8a366c1dbcd1",
      WORKSPACE: "llm-jfa2esgjr4d4w2it",
      stopGenerating: false,
    };
  },
  watch: {
    messages: {
      handler() {
        this.$nextTick(() => {
          const chatBox = this.$el.querySelector(".chat-box");
          if (chatBox) {
            chatBox.scrollTop = chatBox.scrollHeight;
          }
        });
      },
     deep: true
    }
  },
  methods: {
    // 解析 Markdown 为 HTML
    parseMarkdown(content) {
      return marked(content);
    },
    async sendMessage() {
      if (!this.userInput.trim()) return;
      // 禁用输入
      this.loading = true;
      this.stopGenerating = false;

      // 记录用户消息
      this.messages.push({ role: "user", content: this.userInput });
      const userMessage = this.userInput;
      this.userInput = "";
      // 添加 AI 预留消息（逐步更新）
        const aiMessage = { role: "ai", content: "" };
      this.messages.push(aiMessage);
      try {
        const response = await fetch(
            `https://dashscope.aliyuncs.com/api/v1/apps/${this.API_ID}/completion`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-DashScope-SSE":"enable",
                Authorization: `Bearer ${this.API_KEY}`,
              },
              body: JSON.stringify({
                workspace: this.WORKSPACE,
                input: { prompt: userMessage },
                parameters: { temperature: 0.7,incremental_output:true },
                stream: true, // 开启流式输出
              }),
            }
        );

        // 读取流式数据
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let partialData = "";

        // eslint-disable-next-line no-constant-condition
        while (true) {
          if (this.stopGenerating) break; // 停止响

          const { done, value } = await reader.read();
          if (done) break;

          // 解码流数据
          partialData += decoder.decode(value, { stream: true });

          // 解析 SSE 格式的数据
          const lines = partialData.split("\n");
          partialData = lines.pop(); // 处理未完成的 JSON

          for (const line of lines) {
            if (line.startsWith("data:")) {
              try {
                const jsonData = JSON.parse(line.replace(/^data:\s*/, ""));
                const newText = jsonData.output.text || "";
                aiMessage.content += newText; // 逐步更新 AI 消息

                // 处理完成信号
                if (jsonData.output.finish_reason === "stop") {
                  this.loading = false;
                }
              } catch (err) {
                console.error("JSON 解析错误:", err);
              }
            }
          }
        }
      } catch (error) {
        console.error("请求失败", error);
        aiMessage.content = "请求失败，请稍后重试。";
      }

      // 允许发送
      this.loading = false;
    },
    stopResponse() {
      this.stopGenerating = true;
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.chat-container {
  width: 2048px;
  height: 80%;
  margin: 300px auto;
  padding: 16px;
  font-size: 32px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background: #25446b;
  color: #FFFF;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .title {
    text-align: center;
    font-weight: bold;
  }

}
.chat-box {
  overflow-y: auto;
  max-height: 1800px;
  border-radius: 4px;
  background: #25446b;
  padding: 35px;

}
.message {
  margin-bottom: 10px;
  display: flex;
}
.message.user {
  justify-content: flex-end;
}
.message.ai {
  justify-content: flex-start;
}
.bubble {
  padding: 8px 12px;
  border-radius: 16px;
  max-width: 75%;
  word-wrap: break-word;
}
.user .bubble {
  background: #007bff;
  color: white;
}
.ai .bubble {
  background: #4d5782;
  color: #f4f4f4;
}
.input-box {
  display: flex;
  margin-top: 20px;
}
.input-field {
  flex-grow: 1;
  padding: 8px;
  font-size: 32px;
  border: 1px solid #ccc;
  height: 75px;
  border-radius: 4px;
  color: #dbd7d7;
}
.send-button {
  padding: 8px 16px;
  background: #135bcd;
  color: white;
  font-size: 32px;
  border: none;
  cursor: pointer;
  margin-left: 8px;
  border-radius: 4px;
}
.stop-button {
  padding: 8px 16px;
  background: #135bcd;
  color: white;
  font-size: 32px;
  border: none;
  cursor: pointer;
  margin-left: 8px;
  border-radius: 4px;
}
.send-button:disabled {
  background: #aaa;
}
</style>